<template>
  <div
    ref="refSelectOption"
    class="w-full p-2 hover:bg-white backdrop-blur-2xl"
    :class="[
      computedUnavailable
        ? '!cursor-not-allowed opacity-30'
        : 'cursor-pointer',
    ]"
    @click="computedUnavailable
      ? []
      : methodSelectOption()
    "
    >
    <span>
      <i v-if="refSelect?.is_multiple && refSelect.model?.includes(props?.text ?? props.value)" class="fas fa-check mr-2"/>

      <slot>
        {{text}}
        {{ (!text) ? value : '' }}
      </slot>
    </span>
  </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, onMounted } from "vue";

const props = defineProps<{
	text?: string
	value?: string
	default?: boolean
  disabled?: boolean
}>()

const refSelectOption = ref<any>()
const refSelect = ref<any>()

const { locale } = useI18n()

onMounted(() => {
  methodRegisterOption()
})

const methodRegisterOption = () => {

  if (!refSelect.value) {
    refSelect.value = getCurrentInstance()?.proxy?.$parent;
    if (!refSelect.value) {
      return console.warn('SelectOption: refSelect is not defined');
    }
  }

  refSelect.value.methodRegisterSelectOption(
    props.text,
    props.value,
    props.default
  )

  setTimeout(() => {
    if(!refSelect.value.model && props.default){
      methodSelectOption(true)
    }
  }, 30)
}

const methodSelectOption = (is_defaulting: boolean|any = false) => {
  if(!refSelect.value){
    refSelect.value = getCurrentInstance()?.proxy?.$parent;

    if(!refSelect.value){
      return console.warn('SelectOption: refSelect is not defined')
    }
  }

  refSelect.value?.methodSelectOption(
    props.text,
    props.value,
    is_defaulting
  )
}

const computedUnavailable = computed(() => {
  return props?.disabled || ((refSelect.value?.model && !refSelect.value?.is_multiple) == (props?.text ?? props.value));
});

onBeforeUnmount(() => {
  refSelect.value?.methodUnregisterSelectOption(
    props.text,
    props.value
  )
})

watch(locale, () => {
  refSelect.value?.methodUnregisterSelectOption(
    props.text,
    props.value
  )

  methodRegisterOption()
})
</script>
